import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import CustomCheckBox from '../CustomCheckBox';
import toggleRegisterForm from '../../store/actions/registerFormToggle';

// const registerFormBottomText = () => {
//
// };
function RegisterFormBottom({
  checked, setChecked, uniqueId, type,
}) {
  const { translations } = useSelector((state) => state.translation);
  const lang = Cookies.get('i18next') || 'en';
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleOpenSignUp = () => {
    dispatch(toggleRegisterForm({ visible: true, type: 'forgot' }));
  };
  return (
    <div>
      <div style={{ width: '100%' }} className="checkboxContainer">
        <CustomCheckBox onChange={setChecked} checked={checked} uniqueId={uniqueId} />
        {type === 'register' ? (
          <p style={{ cursor: 'pointer' }} role="presentation" className="checkBoxLabel" onClick={() => setChecked(!checked)}>
            {translations.agree_whith[lang]}
            <span
              onClick={() => {
                navigate(`/${lang}/privacy-policy`);
                dispatch(toggleRegisterForm({ visible: false, type: 'signup' }));
              }}
              role="presentation"
              className="checkBoxLabel__link"
            >
              {translations.tems_and_cond[lang]}
            </span>
          </p>
        ) : (
          <div className="login-form-bottom">
            <p style={{ cursor: 'pointer' }} role="presentation" onClick={() => setChecked(!checked)} className="checkBoxLabel">
              {t('remember_me')}
            </p>
            <button onClick={handleOpenSignUp} type="button">
              {t('Forgot Password')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default RegisterFormBottom;
